import { Component, h, Prop, State } from '@stencil/core';
import type { Site } from '../../types/common';
import { SEARCH_URLS, SITE_TO_LANG } from '../../utils/constants';
import { TRANSLATIONS } from './translations';

@Component({
  tag: 'hd-sticky-header',
  styleUrl: 'hd-sticky-header.pcss',
  shadow: true,
})
export class HdStickyHeader {
  @Prop() site: Site = 'us';
  @State() isSticky: boolean = false;

  private headerRef?: HTMLElement;

  componentDidLoad() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  private handleScroll() {
    if (this.headerRef) {
      const scrollPosition = window.scrollY;
      this.isSticky = scrollPosition > 0;
    }
  }

  render() {
    return (
      <header 
        ref={el => this.headerRef = el} 
        class={{ 'sticky-header': true, 'is-sticky': this.isSticky }}
      >
        <div class="header-content">
          <div class="logo-section">
            <picture>
              <source srcSet="https://assets.adsttc.com/doodles/flat/logo-white-full.svg"
                media="(prefers-color-scheme: dark)" />
              <img src="https://assets.adsttc.com/doodles/flat/logo-blue-full.svg"
                alt="ArchDaily Logo" />
            </picture>
          </div>
          
          <form class="search-form" id="afd-search-actions"
            action={SEARCH_URLS[this.site]}>
            <hd-icon class="search-icon" svg="search" />
            <input
              class="search-input"
              name="text"
              type="text"
              placeholder={TRANSLATIONS[SITE_TO_LANG[this.site]]['search-placeholder']}// This needs to be translated
              autocomplete="off"
              aria-controls="top-search"
              aria-label="Search"
              data-insights-category="jv-header"
              data-insights-label="main-search"
              data-insights-value="search"
            />
          </form>

          <nav class="navigation">
            <a href="/search/projects">Projects</a>
            <a href="/search/images">Images</a>
            <a href="/search/products">Products</a>
            <a href="/search/professionals">Professionals</a>
            <a href="/architecture-news">News</a>
            {this.site === 'us' && <a href="/subscribe">Archive</a>}
          </nav>

          <div class="auth">
            <slot name="auth" />
          </div>
          <div class="menu">
            <slot name="menu" />
          </div>
        </div>
      </header>
    );
  }
}
